// Partner-Pharmacies auth session (sessionStorage).
const KEY = "pp_auth_token";

export const setToken = (t) => sessionStorage.setItem(KEY, t);
export const getToken = () => sessionStorage.getItem(KEY) || "";
export const clearToken = () => sessionStorage.removeItem(KEY);
export const isAuthed = () => !!sessionStorage.getItem(KEY);
